import * as React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Card, Grid } from '@upperhand/playmaker';

import AvatarWithTextContainer from 'components/AvatarWithTextContainer';
import SessionTimeAndResource from 'components/SessionTimeAndResource';
import { getAvatarContent } from 'types/Staff';

const SessionItem = ({ eventTitle, resources, sessionId, session, staff }) => {
  const history = useHistory();

  const avatarContent = getAvatarContent(
    session.staffIds.map(staffId => staff[staffId])
  );

  const handleClickSession = () => {
    history.push(`/sessions/${sessionId}`);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card onClick={handleClickSession}>
          <div className="card-content">
            <Grid container justify="space-between" wrap="nowrap">
              <AvatarWithTextContainer
                avatarName={avatarContent.avatarName}
                primaryText={eventTitle}
                src={avatarContent.src}
                subText={avatarContent.subText}
              />
              <SessionTimeAndResource resources={resources} session={session} />
            </Grid>
          </div>
        </Card>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = ({ entities }, { sessionId }) => {
  const resources = entities.resources.data;
  const session = entities.sessions.data[sessionId];
  const eventTitle = entities.events.data[session.eventId]?.title || '';

  const sessionResources = session.resourceIds.map(
    resourceId => resources[resourceId]
  );

  const staff = entities.staff.data;

  return {
    eventTitle,
    resources: sessionResources,
    session,
    staff,
  };
};

export default connect(mapStateToProps)(SessionItem);
